/* schneller-fahren.com · Theme JS v2 · Shopify Cart API */
(function () {
  'use strict';

  /* ── HELPERS ─────────────────────── */
  function formatMoney(cents) {
    return '\u20AC' + (cents / 100).toFixed(2).replace('.', ',');
  }

  /* ── SHOPIFY CART API ────────────── */
  function cartFetch(url, method, body) {
    var opts = { method: method || 'GET', headers: {} };
    if (body) {
      opts.headers['Content-Type'] = 'application/json';
      opts.headers['Accept'] = 'application/json';
      opts.body = JSON.stringify(body);
    } else {
      opts.headers['Accept'] = 'application/json';
    }
    return fetch(url, opts).then(function (r) {
      if (!r.ok) return r.text().then(function (t) { throw new Error(t); });
      return r.json();
    });
  }

  /* ── CART RENDER ─────────────────── */
  function renderCart(cart) {
    if (!cart || typeof cart.item_count === 'undefined') return;
    var count = cart.item_count;
    var body = document.getElementById('cart-body');
    var subtotal = document.getElementById('cart-subtotal');
    var countEls = document.querySelectorAll('.js-cart-count');
    var drawerCount = document.querySelector('.cart-drawer-count');

    countEls.forEach(function (el) { el.textContent = count; });
    document.querySelectorAll('.cart-bubble').forEach(function (b) {
      b.textContent = count;
      b.classList.toggle('show', count > 0);
    });
    if (drawerCount) drawerCount.textContent = count + ' Artikel';
    if (subtotal) subtotal.textContent = formatMoney(cart.total_price);

    var mbbPrice = document.querySelector('.mbb-now');
    if (mbbPrice && cart.items.length > 0) mbbPrice.textContent = formatMoney(cart.total_price);

    if (!body) return;

    if (cart.items.length === 0) {
      body.innerHTML =
        '<div class="cart-empty">' +
        '<div class="cart-empty-icon">\uD83D\uDED2</div>' +
        '<p>Dein Warenkorb ist leer</p>' +
        '<a href="#products" class="btn btn-outline btn-sm" onclick="closeCart()">Produkte ansehen \u2192</a>' +
        '</div>';
      return;
    }

    body.innerHTML = cart.items.map(function (item) {
      var img = item.image
        ? '<img src="' + item.image.replace(/(\.\w+)(\?.*)?$/, '_100x$1') + '" alt="" class="cart-item-thumb">'
        : '<div class="cart-item-img">\u26A1</div>';
      return (
        '<div class="cart-item">' +
        img +
        '<div class="cart-item-info">' +
        '<div class="cart-item-brand">' + (item.vendor || '') + '</div>' +
        '<div class="cart-item-name">' + item.product_title + '</div>' +
        (item.variant_title && item.variant_title !== 'Default Title' ? '<div class="cart-item-variant">' + item.variant_title + '</div>' : '') +
        '<div class="cart-item-price">' + formatMoney(item.final_line_price) + '</div>' +
        '<div class="cart-item-qty">' +
        '<button class="qty-btn" onclick="sfChangeQty(\'' + item.key + '\',' + (item.quantity - 1) + ')">\u2212</button>' +
        '<span class="qty-num">' + item.quantity + '</span>' +
        '<button class="qty-btn" onclick="sfChangeQty(\'' + item.key + '\',' + (item.quantity + 1) + ')">+</button>' +
        '</div>' +
        '</div>' +
        '<button class="cart-item-remove" onclick="sfRemoveFromCart(\'' + item.key + '\')" aria-label="Entfernen">\u00D7</button>' +
        '</div>'
      );
    }).join('');
  }

  function refreshCart() {
    return cartFetch('/cart.js').then(renderCart).catch(function (e) {
      console.warn('[SF] Cart fetch error:', e);
    });
  }

  /* ── ADD TO CART ─────────────────── */
  window.addToCart = function (btn, variantId, qty) {
    if (!variantId) {
      showToast('Produkt nicht verf\u00FCgbar', '\u26A0\uFE0F');
      return;
    }

    var origHTML = btn ? btn.innerHTML : '';
    if (btn) { btn.innerHTML = '<span class="btn-spinner"></span>'; btn.disabled = true; }

    cartFetch('/cart/add.js', 'POST', {
      items: [{ id: Number(variantId), quantity: qty || 1 }]
    })
    .then(function (data) {
      var name = data.items && data.items[0] ? data.items[0].product_title : 'Artikel';
      showToast(name + ' im Warenkorb!', '\u2713');
      if (btn) {
        btn.innerHTML = '\u2713 Hinzugef\u00FCgt!';
        btn.classList.add('success');
        setTimeout(function () { btn.innerHTML = origHTML; btn.classList.remove('success'); btn.disabled = false; }, 2200);
      }
      return refreshCart();
    })
    .then(function () { openCart(); })
    .catch(function (err) {
      console.error('[SF] Add to cart error:', err);
      var msg = 'Fehler beim Hinzuf\u00FCgen';
      try { var parsed = JSON.parse(err.message); if (parsed.description) msg = parsed.description; } catch(e) {}
      showToast(msg, '\u26A0\uFE0F');
      if (btn) { btn.innerHTML = origHTML; btn.disabled = false; }
    });
  };

  /* ── CHANGE QTY / REMOVE ─────────── */
  window.sfChangeQty = function (key, qty) {
    if (qty < 1) { sfRemoveFromCart(key); return; }
    cartFetch('/cart/change.js', 'POST', { id: key, quantity: qty })
      .then(renderCart)
      .catch(function (e) { console.warn('[SF] Qty change error:', e); });
  };
  // Alias for backwards compat
  window.changeQty = window.sfChangeQty;

  window.sfRemoveFromCart = function (key) {
    cartFetch('/cart/change.js', 'POST', { id: key, quantity: 0 })
      .then(function (cart) { renderCart(cart); showToast('Artikel entfernt', '\uD83D\uDDD1\uFE0F'); })
      .catch(function (e) { console.warn('[SF] Remove error:', e); });
  };
  window.removeFromCart = window.sfRemoveFromCart;

  /* ── CART DRAWER ─────────────────── */
  window.openCart = function () {
    var d = document.getElementById('cart-drawer');
    var o = document.getElementById('overlay');
    if (d) d.classList.add('open');
    if (o) o.classList.add('show');
    document.body.style.overflow = 'hidden';
  };

  window.closeCart = function () {
    var d = document.getElementById('cart-drawer');
    var o = document.getElementById('overlay');
    var n = document.getElementById('mobile-nav');
    if (d) d.classList.remove('open');
    if (!n || !n.classList.contains('open')) { if (o) o.classList.remove('show'); }
    document.body.style.overflow = '';
  };

  /* ── LEGAL CHECKBOXES ─────────────── */
  window.sfCheckLegal = function () {
    var c1 = document.getElementById('check-widerruf');
    var c2 = document.getElementById('check-privat');
    var btn = document.getElementById('cart-checkout-btn');
    if (c1 && c2 && btn) {
      btn.disabled = !(c1.checked && c2.checked);
    }
  };

  window.goToCheckout = function () {
    var c1 = document.getElementById('check-widerruf');
    var c2 = document.getElementById('check-privat');
    if (c1 && !c1.checked || c2 && !c2.checked) {
      showToast('Bitte beide Bedingungen akzeptieren', '\u26A0\uFE0F');
      return;
    }
    cartFetch('/cart.js').then(function (cart) {
      if (cart.item_count === 0) { showToast('Warenkorb ist leer', '\u26A0\uFE0F'); return; }
      window.location.href = '/checkout';
    }).catch(function () {
      window.location.href = '/checkout';
    });
  };

  /* ── MOBILE NAV ──────────────────── */
  window.openNav = function () {
    var n = document.getElementById('mobile-nav');
    var o = document.getElementById('overlay');
    var h = document.querySelector('.btn-hamburger');
    if (n) n.classList.add('open');
    if (o) o.classList.add('show');
    if (h) h.classList.add('open');
    document.body.style.overflow = 'hidden';
  };

  window.closeNav = function () {
    var n = document.getElementById('mobile-nav');
    var o = document.getElementById('overlay');
    var h = document.querySelector('.btn-hamburger');
    var d = document.getElementById('cart-drawer');
    if (n) n.classList.remove('open');
    if (!d || !d.classList.contains('open')) { if (o) o.classList.remove('show'); }
    if (h) h.classList.remove('open');
    document.body.style.overflow = '';
  };

  /* ── OVERLAY ─────────────────────── */
  document.addEventListener('click', function (e) {
    if (e.target.id === 'overlay') { closeCart(); closeNav(); }
  });

  /* ── FAQ ACCORDION ───────────────── */
  document.addEventListener('click', function (e) {
    var q = e.target.closest('.faq-q');
    if (!q) return;
    var item = q.closest('.faq-item');
    var isOpen = item.classList.contains('open');
    document.querySelectorAll('.faq-item.open').forEach(function (i) { i.classList.remove('open'); });
    if (!isOpen) item.classList.add('open');
  });

  /* ── PRODUCT FILTER ──────────────── */
  window.filterProducts = function (btn, cat) {
    document.querySelectorAll('.filter-btn').forEach(function (b) { b.classList.remove('active'); });
    btn.classList.add('active');
    document.querySelectorAll('.product-card[data-cat]').forEach(function (c) {
      c.style.display = (cat === 'all' || c.dataset.cat === cat) ? '' : 'none';
    });
  };

  /* ── HEADER SCROLL ───────────────── */
  function initHeaderScroll() {
    var h = document.querySelector('.site-header');
    if (!h) return;
    var fn = function () { h.classList.toggle('scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', fn, { passive: true });
    fn();
  }

  /* ── SCROLL REVEAL ───────────────── */
  function initReveal() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('visible'); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('visible'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -32px 0px' });
    document.querySelectorAll('.reveal').forEach(function (el) { obs.observe(el); });
  }

  /* ── SPEED BAR ANIMATION ─────────── */
  function initSpeedBars() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.speed-bar-fill').forEach(function (el) { el.classList.add('go'); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('go'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.5 });
    document.querySelectorAll('.speed-bar-fill').forEach(function (el) { obs.observe(el); });
  }

  /* ── COUNTDOWN TIMER ─────────────── */
  function initCountdown() {
    var h = document.getElementById('cd-h');
    var m = document.getElementById('cd-m');
    var s = document.getElementById('cd-s');
    if (!h) return;
    var KEY = 'sf_offer_exp';
    var exp = parseInt(localStorage.getItem(KEY) || '0', 10);
    var now = Date.now();
    if (!exp || exp < now) { exp = now + 3 * 3600 * 1000; localStorage.setItem(KEY, String(exp)); }
    var tick = function () {
      var d = Math.max(0, Math.floor((exp - Date.now()) / 1000));
      h.textContent = String(Math.floor(d / 3600)).padStart(2, '0');
      m.textContent = String(Math.floor((d % 3600) / 60)).padStart(2, '0');
      s.textContent = String(d % 60).padStart(2, '0');
    };
    tick(); setInterval(tick, 1000);
  }

  /* ── TOAST ───────────────────────── */
  function showToast(msg, icon) {
    var t = document.getElementById('sf-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'sf-toast';
      t.className = 'sf-toast';
      t.innerHTML = '<div class="toast-dot" id="toast-icon"></div><span id="toast-msg"></span>';
      document.body.appendChild(t);
    }
    document.getElementById('toast-icon').textContent = icon || '\u2713';
    document.getElementById('toast-msg').textContent = msg;
    t.classList.add('show');
    clearTimeout(t._t);
    t._t = setTimeout(function () { t.classList.remove('show'); }, 3000);
  }
  window.showToast = showToast;

  /* ── MOBILE STICKY BAR ───────────── */
  function initMobileBar() {
    var bar = document.querySelector('.mobile-buy-bar');
    if (!bar) return;
    var hero = document.querySelector('.hero');
    if (!hero) return;
    if (!('IntersectionObserver' in window)) return;
    var obs = new IntersectionObserver(function (entries) {
      bar.style.display = entries[0].isIntersecting ? 'none' : 'block';
    }, { threshold: 0 });
    obs.observe(hero);
  }

  /* ── INIT ────────────────────────── */
  document.addEventListener('DOMContentLoaded', function () {
    refreshCart();
    initHeaderScroll();
    initReveal();
    initSpeedBars();
    initCountdown();
    initMobileBar();
  });

})();
